module.exports = __webpack_public_path__ + "static/media/delete.9946dc82.svg";